import {required} from "vuelidate/lib/validators";  
const dpagecategoriestranslations = {
    data() { 
      return {   
        dpagecategoriestranslationsData: { 
          Title: "", 
          Dpagecategoryid: "",
          Langid: "",
          Websiteid: null,
          Deleted: false
          }, 

  
          FormDataType:{
            Title:{FieldName:"Title",Field:"input",FieldTitle:this.$t('dpages.AddEdit.Title')},  
            Dpagecategoryid:{FieldName:"Dpagecategoryid",Field:"input"}, 
            Langid:{FieldName:"Langid",Field:"input"}, 
            Websiteid:{FieldName:"Websiteid",Field:"input"}, 
          
          
          } 
      }
    },  
    validations:{ 
      FormData: {  
        Title:{required},   
        Dpagecategoryid:{},
        Langid:{},
        Websiteid:{}


       


      }
 
  },
  created(){

  }
}
export default dpagecategoriestranslations